export const getPricingOfAccountEmailValidationCampaign = {
  GET_PRICING_OF_ACCOUNT_EMAIL_VALIDATION_CAMPAIGN_REQUEST: "GET_PRICING_OF_ACCOUNT_EMAIL_VALIDATION_CAMPAIGN_REQUEST",
  GET_PRICING_OF_ACCOUNT_EMAIL_VALIDATION_CAMPAIGN_SUCCESS: "GET_PRICING_OF_ACCOUNT_EMAIL_VALIDATION_CAMPAIGN_SUCCESS",
  GET_PRICING_OF_ACCOUNT_EMAIL_VALIDATION_CAMPAIGN_ERROR: "GET_PRICING_OF_ACCOUNT_EMAIL_VALIDATION_CAMPAIGN_ERROR",
};

export const editPricingOfAccountEmailValidationCampaign = {
  EDIT_PRICING_OF_ACCOUNT_EMAIL_VALIDATION_CAMPAIGN_REQUEST: "EDIT_PRICING_OF_ACCOUNT_EMAIL_VALIDATION_CAMPAIGN_REQUEST",
  EDIT_PRICING_OF_ACCOUNT_EMAIL_VALIDATION_CAMPAIGN_SUCCESS: "EDIT_PRICING_OF_ACCOUNT_EMAIL_VALIDATION_CAMPAIGN_SUCCESS",
  EDIT_PRICING_OF_ACCOUNT_EMAIL_VALIDATION_CAMPAIGN_ERROR: "EDIT_PRICING_OF_ACCOUNT_EMAIL_VALIDATION_CAMPAIGN_ERROR",
};
